// extracted by mini-css-extract-plugin
export default {"textFieldContainer":"CareElementTextAreaField_textFieldContainer__iZTI-","textFieldArea":"CareElementTextAreaField_textFieldArea__pLs7c"};